import { Component, inject } from '@angular/core';
import { Toast } from '../../types/toast';
import { LayoutStore, LayoutStoreType } from '../../../core/store/layout.store';

@Component({
    selector: 'juyo-toast-container',
    styleUrl: 'toast-container.scss',
    template: `
        <div class="toast-container">
            @for (toast of layoutStore.toasts(); track toast.id) {
                <div
                    class="toast shown show"
                    [class.toast--success]="toast.isSuccess"
                    [class.toast--error]="toast.isError"
                    [class.toast--warning]="toast.isWarning"
                    [class.toast--info]="toast.isInfo"
                >
                    <div class="toast-title">
                        <span>{{ toast.type }}</span>
                        <span class="toast-close" (click)="onRemove(toast)">
                        <span class="material-symbols-outlined"> close_small </span>
                    </span>
                    </div>
                    <div class="toast-message">
                        @for (message of toast.messages; track $index) {
                            <div class="toast-message-text">{{ message }}</div>
                        }
                    </div>
                </div>
            }
        </div>
    `
})
export class ToastContainerComponent {

    protected layoutStore: LayoutStoreType = inject(LayoutStore);

    public onRemove(toast: Toast) {
        this.layoutStore.removeToast(toast);
    }
}
